import { render, staticRenderFns } from "./main-head.vue?vue&type=template&id=cbb24374&scoped=true&"
import script from "./main-head.vue?vue&type=script&lang=js&"
export * from "./main-head.vue?vue&type=script&lang=js&"
import style0 from "./main-head.vue?vue&type=style&index=0&id=cbb24374&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb24374",
  null
  
)

export default component.exports